// @ts-nocheck
import { Column } from 'react-table'

import { CouponActionsCell } from './CouponActionsCell'
import { CouponCustomHeader } from './CouponCustomHeader'
import { Coupon } from '../../core/_models'

const usersColumns: ReadonlyArray<Column<Coupon>> = [
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='S.No' className='min-w-125px' />
    ),
    id: 'serialNo',
    Cell: ({ ...props }) => (
      <span>{props.row.index + 1}</span>
    ),
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Code' className='min-w-125px' />
    ),
    accessor: 'code',
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Type' className='min-w-125px' />
    ),
    id: 'discount_type',
    Cell: ({ ...props }) => {
      const type = props.data[props.row.index].discount_type
      return (
        <span>
          {type === 1 || type === '1'
            ? 'Percentage'
            : type === 2 || type === '2'
              ? 'Fixed Amount'
              : type}
        </span>
      )
    },
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Value' className='min-w-125px' />
    ),
    id: 'discount_value',
    Cell: ({ ...props }) => {
      const type = props.data[props.row.index].discount_type
      const value = props.data[props.row.index].discount_value
      return (
        <span>
          {type === 1 || type === '1'
            ? `${Math.round(Number(value))} %`
            : type === 2 || type === '2'
              ? `₹ ${value}`
              : value}
        </span>
      )
    },
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Start Date' className='min-w-125px' />
    ),
    id: 'start_date',
    Cell: ({ ...props }) => (
      <span>
        {props.data[props.row.index].start_date
          ? new Date(props.data[props.row.index].start_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
          : '-'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='End Date' className='min-w-125px' />
    ),
    id: 'end_date',
    Cell: ({ ...props }) => (
      <span>
        {props.data[props.row.index].end_date
          ? new Date(props.data[props.row.index].end_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
          : '-'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => (
      <CouponActionsCell id={props.data[props.row.index].id} cate={props.data[props.row.index]} />
    ),
  },
]

export { usersColumns }
